var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThickBar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 160,
    viewBox: "0 0 394 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357 38C357 36.8954 357.895 36 359 36H392C393.105 36 394 36.8954 394 38V160H357V38Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 73C27 71.8954 27.8954 71 29 71H62C63.1046 71 64 71.8954 64 73V160H27V73Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103C72 101.895 72.8954 101 74 101H107C108.105 101 109 101.895 109 103V160H72V103Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126 33C126 31.8954 126.895 31 128 31H161C162.105 31 163 31.8954 163 33V160H126V33Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183 78C183 76.8954 183.895 76 185 76H218C219.105 76 220 76.8954 220 78V160H183V78Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282 74C282 72.8954 282.895 72 284 72H317C318.105 72 319 72.8954 319 74V160H282V74Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M330 2C330 0.895429 330.895 0 332 0H365C366.105 0 367 0.895431 367 2V160H330V2Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 91C0 89.8954 0.89543 89 2 89H35C36.1046 89 37 89.8954 37 91V160H0V91Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153 91C153 89.8954 153.895 89 155 89H188C189.105 89 190 89.8954 190 91V160H153V91Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M234 66C234 64.8954 234.895 64 236 64H269C270.105 64 271 64.8954 271 66V160H234V66Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66C102 64.8954 102.895 64 104 64H137C138.105 64 139 64.8954 139 66V160H102V66Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51 117C51 115.895 51.8954 115 53 115H86C87.1046 115 88 115.895 88 117V160H51V117Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211 14C211 12.8954 211.895 12 213 12H246C247.105 12 248 12.8954 248 14V160H211V14Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M306 91C306 89.8954 306.895 89 308 89H341C342.105 89 343 89.8954 343 91V160H306V91Z",
    fill: "#0F5EFF",
    fillOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M263 46C263 44.8954 263.895 44 265 44H298C299.105 44 300 44.8954 300 46V160H263V46Z",
    fill: "#0F5EFF",
    fillOpacity: 0.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickBar1);
export default __webpack_public_path__ + "static/media/thickBar1.720b8f3527826872ddf7decf9eb18fc4.svg";
export { ForwardRef as ReactComponent };